<template lang="pug">
  .modal.active
    .modal-overlay(@click='closeModal')
    .modal-container
      .modal-header
        button.btn.btn-clear.float-right(@click='closeModal')
        .modal-title.h5 About
      .modal-body
        .content
          p <strong>Nonprofiters is a digital case worker for the homeless and low income communities</strong>.
          p Case workers can get people out of homelessness and help low-income individuals thrive. However, case workers are often overwhelmed with clients causing people to be placed on long waitlists (sometimes as long as a year or more).
          p Nonprofiters helps these individuals in the meantime by offering guidance on how to navigate the massive nonprofit landscape.
          p The shorterm goal is to eventually develop the site into a social network, allowing community members to assist each other. Our longterm goal is to help end homelessness completely in the US by 2050, and globally by 2100.
          p Our vision is a world where the basic requirements to live and innovate are completely free for everyone, everywhere.
      .modal-footer
        a.btn.float-left(href='https://nonprofiters.com/api/getResources' target='_blank') Download Database
        button.btn.btn-primary(@click='closeModal') Close
</template>





<script>
  export default {
    name: 'modal-about',

    methods: {
      closeModal () {
        this.$store.commit('toggleAboutModal')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/About.vue